import { cn } from "@/util/cn";

type PProps = {
  className?: string;
  children: React.ReactNode;
};

export default function P({ className, children }: PProps) {
  return <p className={cn("text-base font-sans", className)}>{children}</p>;
}
